import MainContainer from "../../components/container/MainContainer";

const VarianceReport = () => {
  return <MainContainer>VarianceReport</MainContainer>;
};

export default VarianceReport;
